const buildContentPageUrl = (slug: string) => {
  return `/${slug}`;
};

export default buildContentPageUrl;
